import { z } from "zod";
import { Auth } from "../auth";
import { request } from "../request";
import type { ActionReturnType } from "../types";
import { CycleMessageItem, CycleMessageLevel } from "@/lib/api/schemas/cycleMessage";

class CycleMessagesEndpoint {
  public static readonly basePath = "cycles";
  public static readonly schemas = {
    list: {
      response: z.object({
        count: z.number(),
        items: CycleMessageItem.array(),
      }),
    },
  };

  constructor(private api: Auth) {}

  public list(
    cycleId: string | number,
    query?: { from_id?: number; limit?: number; offset?: number; levels?: CycleMessageLevel[] },
  ): ActionReturnType<z.infer<typeof CycleMessagesEndpoint.schemas.list.response>> {
    return request({
      log: ["CycleMessages", "list"],
      method: "get",
      path: [CycleMessagesEndpoint.basePath, cycleId, "messages"],
      query,
      // The messages endpoint rejects the trailing slash the URL builder appends.
      stripTrailingSlash: true,
      response: CycleMessagesEndpoint.schemas.list.response,
    });
  }
}

export { CycleMessagesEndpoint };
